import { Component, OnInit, HostListener } from '@angular/core';
import { NickNameModalService } from '@app/feature/main/roles-shared/services/nick-name-modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import swal from "sweetalert2";
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-nick-name',
  templateUrl: './nick-name.component.html',
  styleUrls: ['./nick-name.component.css']
})
export class NickNameComponent implements OnInit {

  nickNameModalSubscription;
  userDetailsObject;
  userId;
  nickNameFormGroup: FormGroup;
  userRole: string;
  nickNameErrorMessage:string=null;
  @HostListener('document:keyup', ['$event']) keyups(event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      this.cancel();
    }
  }

  constructor(
    private nickNameModal: NickNameModalService,
    private formBuilder: FormBuilder,
    private nickNameModalService: NickNameModalService,
    private rolesSharedService: RolesSharedService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit() {
    this.nickNameErrorMessage=null;
    this.nickNameModalSubscription = this.nickNameModal.nickNameObservable.subscribe((response: any) => {

      if (response) {

      } else {
        // this.nickNameFormGroup.reset();
      }
    })
    this.userDetails();
    this.createForm();
    this.getRole();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  createForm() {
    this.nickNameFormGroup = this.formBuilder.group({
      nickName: ['', Validators.required]
    })
  }

  cancel() {
    this.nickNameErrorMessage=null;
    this.nickNameFormGroup.reset();
    this.nickNameModalService.close();
  }

  save() {
    this.nickNameErrorMessage=null;
    let nicknameObj: any;
    nicknameObj = JSON.stringify({
      nickName: this.nickNameFormGroup.controls.nickName.value
    });

    this.rolesSharedService.addNickName(nicknameObj, this.userId).subscribe((response: any) => {

      if (response) {

        let localStorageUserDeatils = JSON.parse(window.localStorage.getItem('userDetails'));
        if (localStorageUserDeatils && localStorageUserDeatils != null) {
          localStorageUserDeatils.nickName = response.nickName;
          window.localStorage.setItem('userDetails', JSON.stringify(localStorageUserDeatils));
        }
        let sessionStorageUserDeatils = JSON.parse(window.sessionStorage.getItem('userDetails'));
        if (sessionStorageUserDeatils && sessionStorageUserDeatils != null) {
          sessionStorageUserDeatils.nickName = response.nickName;
          window.sessionStorage.setItem('userDetails', JSON.stringify(sessionStorageUserDeatils));
        }
        this.nickNameModalService.nickNameUpdatedStatus(true);
        swal({
          position: "center",
          type: "success",
          title: "Added Nick name",
          showConfirmButton: false,
          timer: 2000
          // text: "See you back soon"
        });
        this.cancel();
      } else {
        this.cancel();
       this.nickNameModalService.nickNameUpdatedStatus(false);
      }
    },
    (error:any)=>{
     this.nickNameErrorMessage=error.error.error.message;
    }
    );
  }
  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
  navigatePrivacySettingsPage() {
    this.nickNameModalService.nickNameUpdatedStatus(false);
    $(".modal-backdrop").hide();
    $(".modal-open").css('overflow', 'auto');
    $("#nickNameModal").modal('hide');
    this.router.navigate([`${this.userRole}/my-profile`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/nick-name/nick-name.component.ts